import Vue from 'vue'
import Vuex from 'vuex'
import global from '@/utils/global'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userIcon: localStorage.getItem(global.keys.userIconKey),
    username: localStorage.getItem(global.keys.usernameKey),
    userAuth: localStorage.getItem(global.keys.authKey),
  },
  mutations: {
    /**
     * 设置用户信息
     * @param state
     * @param user
     */
    setUserInfo(state, user) {
      // 用户名
      state.username = user.phone
      localStorage.setItem(global.keys.usernameKey, user.phone)


      state.userAuth = user.auth
      localStorage.setItem(global.keys.authKey, user.auth)

      state.userIcon = user.profile
      localStorage.setItem(global.keys.userIconKey, user.profile)
    },
  },
  actions: {},
  modules: {},
})
